module.exports = __webpack_public_path__ + "img/carousel-vet-13.8e3fecb5.jpg";